"use client"

import { Archive } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArchiveIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArchiveIcon = component(Icon)({ as: Archive })
